import {
  SELECT_REAGENT_OPTION,
  SUBMIT_REAGENT_ANSWER
} from '../Redux.constants';
import {COMPONENT_TYPE} from '@learningblocks/protocol-constants/lib/Utilities';

export const selectReagentOption = (option) => ({
  type: SELECT_REAGENT_OPTION,
  payload: option,
});

export const submitReagentAnswer = (componentID, type) => ({
  type: getSubmitAnswerType(type),
  payload: {componentID},
});

function getSubmitAnswerType(type) {
  if (type === COMPONENT_TYPE.REAGENT_DRAG_DROP) {
    return SUBMIT_REAGENT_ANSWER;
  } else {
    return null;
  }
}
